import React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import { incrementStep, decrementStep, setFormData } from '../../redux/actions';

const ContractorStep14 = ( { incrementStep, decrementStep, formData } ) => {
  const validated = formData.termsAndConditions;

  return(
    <>NOT USED SKIP THIS STEP</>
  )
};

const mapStateToProps = state => (
  {
    formData: state.formData,
  }
);

const mapDispatchToProps = dispatch => (
  {
    incrementStep: () => dispatch(incrementStep()),
    decrementStep: () => dispatch(decrementStep()),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractorStep14);
